/* Framing landing page (product template "framed-prints"), v2 2026-10-07; sharp size + tracking 2026-10-21.
 *
 * 1. Hero 3D frame: swings in on load, flashes the glass, then sways and
 *    cycles black/white like an ad until the visitor touches anything.
 * 2. "Try it with your photo": a local preview only (object URL). Every
 *    img[data-frl-photo] on the page switches to the visitor's photo.
 * 3. "See it on your wall": the order page's own room shot and calibration
 *    (sofa ~1.2 m), so sizes are true to scale. Size strip = to-scale thumbnails.
 * 4. Prices come from the order page's live pricing (/apps/print/api/pricing);
 *    the numbers baked in below are pricing v24 and only show if that fails.
 * 5. Ordering: with a photo, the File is handed to the order page through
 *    IndexedDB (same origin) and the order page opens with it uploaded and
 *    the frame picked. Without one, it is a plain link.
 *
 * 6. Sharpness (2026-10-21): with a photo tried on, the selected size becomes the
 *    LARGEST frame that photo prints sharply at, using the order page's own
 *    Print Check (centred crop, fine art 180 DPI / photo paper 100 DPI, live
 *    from pricing.printCheck). A size the visitor picks is kept but warned
 *    about, and a photo too small for every frame is not handed off.
 * 7. Tracking: frl_* events to the theme dataLayer (GTM) and Clarity.
 *
 * Motion: the hero animates for everyone, including devices set to reduce motion
 * (owner 2026-10-07: it has to catch the eye). ?motion=off switches it off.
 */
(function () {
  'use strict';
  var root = document.getElementById('frl');
  if (!root || root.getAttribute('data-frl-init')) return;
  root.setAttribute('data-frl-init', '1');

  var q = new URLSearchParams(location.search);
  var motion = q.get('motion');
  // Animates for everyone, even with reduce motion switched on (owner 2026-10-07); ?motion=off stops it.
  var reduced = motion === 'off';
  if (!reduced) root.classList.add('frl-force-motion');

  var IN = 0.0254;
  var MOULD_IN = 0.85;                  // timber moulding width each side, inches (about 22 mm)
  var ROOM = { fracPerMetre: 0.3125, anchorX: 0.47, bottomY: 0.6, imgAspect: 1600 / 1240, topMargin: 0.06 };
  var TIER_LABEL = { ctype: 'Photo paper', standard: 'Bauhaus', premium: 'Fine art' };
  var TIER_LONG = { ctype: 'C-Type photo paper', standard: 'Bauhaus paper', premium: 'Ilford fine art paper' };
  var HANDOFF_DB = 'rpl-handoff', HANDOFF_STORE = 'items', HANDOFF_KEY = 'framing';

  /* Frame sizes, the print each one holds, and pricing v24 as a fallback. */
  var SIZES = [
    { key: '8x10', label: '8x10″', cm: '20x25 cm', frame: [8, 10],
      edge: { print: '8x10', inches: [8, 10], border: 'printToEdge', prices: { standard: 74.95, premium: 79.9 } },
      matt: { print: '5x7', inches: [5, 7], border: 'doubleMatt', prices: { ctype: 61 } } },
    { key: '12x16', label: '12x16″', cm: '30x41 cm', frame: [12, 16],
      edge: { print: '12x16', inches: [12, 16], border: 'printToEdge', prices: { standard: 116.95, premium: 127.95 } },
      matt: { print: '8x12', inches: [8, 12], border: 'doubleMatt', prices: { ctype: 95.4, standard: 102.95, premium: 107.9 } } },
    { key: '16x22', label: '16x22″', cm: '41x56 cm', frame: [16, 22],
      edge: { print: '16x22', inches: [16, 22], border: 'printToEdge', prices: { standard: 163.95, premium: 186.95 } },
      matt: { print: '12x18', inches: [12, 18], border: 'doubleMatt', prices: { standard: 140.95, premium: 153.95 } } },
    { key: 'A2', label: 'A2', cm: '42x59 cm', frame: [16.54, 23.39],
      edge: { print: 'A2', inches: [16.54, 23.39], border: 'printToEdge', prices: { standard: 179.95, premium: 201.95 } },
      matt: { print: 'A3', inches: [11.69, 16.54], border: 'singleMatt', prices: { standard: 153.95, premium: 164.95 } } },
    { key: '20x30', label: '20x30″', cm: '51x76 cm', frame: [20, 30],
      edge: { print: '20x30', inches: [20, 30], border: 'printToEdge', prices: { standard: 269.95, premium: 304.95 } },
      matt: { print: '16x24', inches: [16, 24], border: 'singleMatt', prices: { standard: 238.95, premium: 261.95 } } }
  ];

  var state = {
    colour: root.getAttribute('data-colour') === 'white' ? 'white' : 'black',
    size: 'A2', style: 'edge', tier: 'standard',
    file: null, url: null, landscape: false,
    px: null,           // [width, height] of the visitor's photo
    sizeChosen: false   // true once the visitor picks a size themselves
  };
  /* The order page can only add a framed print whose print size it also sells loose
     (fa-/ct- catalogue). 16x22 edge to edge is frame-only, so its Add button does
     nothing there (found 2026-10-21): never pick it automatically. Live pricing
     recomputes this in applyPricing, so it heals if 16x22 is ever sold loose. */
  sizeObj('16x22').edge.orderable = false;
  /* The order page's Print Check thresholds (pricing.printCheck); live values replace these. */
  var CHECK = { minDpi: { ctype: 100, fineArt: 180 } };

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function money(n) { return '$' + (Math.round(n * 100) % 100 ? n.toFixed(2) : String(Math.round(n))); }
  function sizeObj(key) { for (var i = 0; i < SIZES.length; i++) if (SIZES[i].key === key) return SIZES[i]; return SIZES[0]; }
  function opt() { var s = sizeObj(state.size); return s[state.style]; }
  function tiersOf(o) { return ['ctype', 'standard', 'premium'].filter(function (t) { return o.prices[t] != null; }); }
  function fromPrice(o) { var t = tiersOf(o); var m = Infinity; t.forEach(function (k) { m = Math.min(m, o.prices[k]); }); return m; }
  function track(name, extra) {
    try { window.dataLayer = window.dataLayer || []; var e = { event: name }; for (var k in extra) e[k] = extra[k]; window.dataLayer.push(e); } catch (err) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (err) {}
  }
  function sizeName(key) { return key + (/^A\d$/.test(key) ? '' : '″'); }

  /* ---------------- sharpness (same rule as the order page's Print Check) ---------------- */
  // Effective DPI of the photo on a print of these inches, after the centred crop the
  // order page applies by default (orientation follows the photo; matches checkPrint).
  function dpiOn(inches) {
    if (!state.px) return Infinity;
    var w = state.px[0], h = state.px[1];
    var pl = Math.max(inches[0], inches[1]), ps = Math.min(inches[0], inches[1]);
    var target = w >= h ? pl / ps : ps / pl, cw, ch;
    if (w / h > target) { ch = h; cw = h * target; } else { cw = w; ch = w / target; }
    cw = Math.round(cw); ch = Math.round(ch);
    return Math.floor(Math.min(Math.min(cw, ch) / ps, Math.max(cw, ch) / pl));
  }
  // The paper tier the panel would show for an option (renderPanel's rule).
  function tierFor(o) {
    var t = tiersOf(o);
    return t.indexOf(state.tier) >= 0 ? state.tier : (t.indexOf('standard') >= 0 ? 'standard' : t[0]);
  }
  function sharpAt(key, style) {
    var o = sizeObj(key)[style];
    var min = tierFor(o) === 'ctype' ? CHECK.minDpi.ctype : CHECK.minDpi.fineArt;
    return dpiOn(o.inches) >= min;
  }
  // Largest frame (by print area) this photo prints sharply in, for one style. null = none.
  function largestSharp(style) {
    var best = null, area = 0;
    SIZES.forEach(function (s) {
      var a = s[style].inches[0] * s[style].inches[1];
      if (s[style].orderable !== false && sharpAt(s.key, style) && a > area) { best = s.key; area = a; }
    });
    return best;
  }
  // With a photo and no size picked by the visitor: open on the largest sharp frame,
  // trying the other style only when the current one has nothing sharp.
  function autoSize() {
    if (!state.px || state.sizeChosen) return;
    var k = largestSharp(state.style);
    if (!k) {
      var other = state.style === 'edge' ? 'matt' : 'edge', k2 = largestSharp(other);
      if (k2) { state.style = other; k = k2; }
    }
    if (k) state.size = k;
  }
  function tooSmallForAll() { return !!state.px && !largestSharp('edge') && !largestSharp('matt'); }
  var TOO_SMALL = 'This photo is too small to print sharply in a frame, even our smallest 8x10″. ' +
    'Try the original full-size photo (not a screenshot or a photo sent through a chat app).';
  // The line under the price: warns when the chosen size is too big for the photo.
  function renderFit() {
    var n = $('[data-frl-fit]');
    if (!n) return;
    var msg = '', fix = null;
    if (state.px) {
      if (tooSmallForAll()) msg = TOO_SMALL;
      else if (!sharpAt(state.size, state.style)) {
        fix = largestSharp(state.style);
        msg = 'Your photo is a little small for the ' + sizeName(state.size) + ' frame and may print soft. ' +
          (fix ? 'It prints sharply up to ' + sizeName(fix) + '.' : 'Try it with a matt instead.');
      }
    }
    var txt = $('[data-frl-fit-text]', n), btn = $('[data-frl-fit-use]', n);
    if (txt) txt.textContent = msg;
    if (btn) { btn.hidden = !fix; btn.textContent = fix ? 'Use ' + sizeName(fix) : ''; btn.setAttribute('data-size', fix || ''); }
    n.hidden = !msg;
  }

  /* ---------------- colour ---------------- */
  var autoTimer = null, interacted = false;
  function setColour(c, byUser) {
    var changed = c !== state.colour;    // the load-time sync must not fire the sheen mid-entrance
    state.colour = c;
    root.setAttribute('data-colour', c);
    $$('[data-frl-colour]').forEach(function (b) { b.setAttribute('aria-checked', String(b.getAttribute('data-frl-colour') === c)); });
    $$('[data-frl-colour-label]').forEach(function (el) { el.textContent = c === 'white' ? 'White' : 'Black'; });
    if (byUser) userTouched();
    if (changed) kick();
  }
  function startAuto() {
    if (autoTimer || interacted) return;
    autoTimer = setInterval(function () {
      if (document.hidden || !heroVisible) return;
      setColour(state.colour === 'black' ? 'white' : 'black', false);
      rotateHero();
    }, reduced ? 4200 : 3000);
    preloadHero(1);
  }
  function stopAuto() { if (autoTimer) clearInterval(autoTimer); autoTimer = null; }
  function userTouched() { interacted = true; stopAuto(); }
  $$('[data-frl-colour]').forEach(function (b) {
    b.addEventListener('click', function () {
      setColour(b.getAttribute('data-frl-colour'), true);
      track('frl_swatch', { frl_kind: 'colour', frl_value: state.colour });
    });
  });

  /* ---------------- hero 3D: entrance, sway, drag ---------------- */
  var stage = $('#frl-3d');
  var heroVisible = true, angle = -14, kickAmp = 0, kickT0 = 0, raf = 0, drag = null;
  function paint(deg) {
    angle = deg;
    root.style.setProperty('--frl-deg', deg.toFixed(2) + 'deg');
    root.style.setProperty('--frl-glare', Math.max(0, Math.min(100, 50 - (deg / 20) * 50)).toFixed(1) + '%');
  }
  var sheenTimer = 0;
  function kick() {
    if (reduced) return;
    kickAmp = 16; kickT0 = performance.now();
    // Glossy sheen across the frame while the colour crossfades, plus a small pop.
    root.classList.remove('is-sheen'); void root.offsetWidth; root.classList.add('is-sheen');
    clearTimeout(sheenTimer);
    sheenTimer = setTimeout(function () { root.classList.remove('is-sheen'); }, 1350);
  }
  var t0 = 0;
  function tick(now) {
    if (!t0) t0 = now;
    if (!drag || !drag.active) {
      var idle = -14 * Math.cos(((now - t0) / 9000) * 2 * Math.PI) * 0.85;
      var k = kickAmp * Math.exp(-(now - kickT0) / 420) * Math.sin((now - kickT0) / 115);
      paint(angle + ((idle + k) - angle) * 0.12);
    }
    raf = requestAnimationFrame(tick);
  }
  if (stage) {
    if (reduced) {
      // Reduced motion: no swing-in and no sway, but turning the frame by hand still works.
      paint(-12);
      root.classList.add('is-still');
    } else {
      root.classList.add('is-entering');
      setTimeout(function () {
        root.classList.remove('is-entering');
        root.classList.add('is-live');
        raf = requestAnimationFrame(tick);
      }, 1550);
    }
    stage.addEventListener('pointerdown', function (e) { if (e.isPrimary) drag = { x: e.clientX, base: angle, active: false }; });
    stage.addEventListener('pointermove', function (e) {
      if (!drag || !e.isPrimary) return;
      var dx = e.clientX - drag.x;
      if (!drag.active) {
        if (Math.abs(dx) < 6) return;
        drag.active = true; stage.classList.add('is-dragging'); userTouched();
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      }
      paint(Math.max(-38, Math.min(38, drag.base + dx * 0.35)));
    });
    var release = function () { if (drag && drag.active) stage.classList.remove('is-dragging'); drag = null; };
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        heroVisible = entries[entries.length - 1].isIntersecting;
        if (reduced) return;
        if (heroVisible && !raf && root.classList.contains('is-live')) raf = requestAnimationFrame(tick);
        if (!heroVisible && raf) { cancelAnimationFrame(raf); raf = 0; }
      }, { threshold: 0.15 }).observe(stage);
    }
  }
  setTimeout(startAuto, reduced ? 1200 : 1900);

  /* ---------------- hero photo rotation (owner 2026-10-07) ----------------
   * Each automatic black/white switch also moves the hero to the next sample photo,
   * crossfading on top while the sheen passes. Stops with the colour cycle (any
   * interaction) and never replaces a visitor's own photo. */
  var heroSamples = [];
  try { heroSamples = JSON.parse((stage && stage.getAttribute('data-frl-hero-samples')) || '[]'); } catch (err) {}
  var heroIdx = 0, heroBusy = false;
  var heroImg = stage ? $('.frl-3d__photo img[data-frl-photo]', stage) : null;
  var heroSource = stage ? $('.frl-3d__photo source[data-frl-photo]', stage) : null;
  var heroNext = stage ? $('.frl-3d__next', stage) : null;
  var narrowMq = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
  function heroUrl(s) {
    var hi = (window.devicePixelRatio || 1) > 1.4;
    return narrowMq && narrowMq.matches ? (hi ? s.l : s.ls) : (hi ? s.p : s.ps);
  }
  function preloadHero(i) { var s = heroSamples[i]; if (s) { var im = new Image(); im.src = heroUrl(s); } }
  function rotateHero() {
    if (heroSamples.length < 2 || !heroImg || !heroNext || state.file || heroBusy) return;
    var i = (heroIdx + 1) % heroSamples.length, s = heroSamples[i];
    heroBusy = true;
    heroNext.onerror = function () { heroNext.onerror = null; heroBusy = false; };
    heroNext.onload = function () {
      heroNext.onload = null;
      heroNext.classList.add('is-in');
      setTimeout(function () {
        var done = function () {
          heroNext.classList.remove('is-in');
          heroNext.removeAttribute('src');
          heroBusy = false;
          preloadHero((heroIdx + 1) % heroSamples.length);
        };
        if (state.file) { done(); return; }        // a visitor's photo arrived meanwhile
        heroIdx = i;
        var pset = s.ps + ' 520w, ' + s.p + ' 1000w', lset = s.ls + ' 520w, ' + s.l + ' 1000w';
        if (heroSource) { heroSource.setAttribute('srcset', lset); heroSource.setAttribute('data-frl-srcset', lset); }
        heroImg.setAttribute('srcset', pset);
        heroImg.setAttribute('data-frl-srcset', pset);
        heroImg.setAttribute('data-frl-src', s.p);
        heroImg.src = s.p;
        heroImg.alt = s.alt;
        if (heroImg.decode) heroImg.decode().then(done, done); else setTimeout(done, 80);
      }, 900);
    };
    heroNext.src = heroUrl(s);
  }

  /* ---------------- frames: room + thumbnails ---------------- */
  function dims(fr, pr) {
    var fw = fr[0], fh = fr[1], pw = pr[0], ph = pr[1];
    if (state.landscape) { var a = fw; fw = fh; fh = a; a = pw; pw = ph; ph = a; }
    return { fw: fw, fh: fh, pw: pw, ph: ph };
  }
  function layout(frameEl, d) {
    var opening = $('.frl-frame__opening', frameEl), print = $('.frl-frame__print', frameEl);
    var W = d.fw + 2 * MOULD_IN, H = d.fh + 2 * MOULD_IN;
    opening.style.left = opening.style.right = (MOULD_IN / W * 100) + '%';
    opening.style.top = opening.style.bottom = (MOULD_IN / H * 100) + '%';
    print.style.left = print.style.right = ((d.fw - d.pw) / 2 / d.fw * 100) + '%';
    print.style.top = print.style.bottom = ((d.fh - d.ph) / 2 / d.fh * 100) + '%';
  }
  var roomFrame = $('[data-frl-roomframe]');
  // The room shows the selected size's sample photo (owner 2026-10-07); a visitor's own photo wins.
  var roomImg = roomFrame ? $('img[data-frl-photo]', roomFrame) : null;
  function syncRoomSample() {
    var btn = roomImg && $('[data-frl-size="' + state.size + '"]');
    var src = btn && btn.getAttribute('data-frl-room-src');
    if (!src) return;
    var ss = btn.getAttribute('data-frl-room-srcset') || '';
    roomImg.setAttribute('data-frl-src', src);     // what "Use the sample photos" restores
    roomImg.setAttribute('data-frl-srcset', ss);
    if (state.file || roomImg.getAttribute('src') === src) return;
    roomImg.alt = btn.getAttribute('data-frl-room-alt') || '';
    roomImg.style.opacity = '0';
    var show = function () { roomImg.style.opacity = ''; };
    roomImg.onload = show; roomImg.onerror = show; setTimeout(show, 700);
    if (ss) roomImg.setAttribute('srcset', ss); else roomImg.removeAttribute('srcset');
    roomImg.src = src;
  }
  function renderRoom() {
    if (!roomFrame) return;
    syncRoomSample();
    var s = sizeObj(state.size), o = opt(), d = dims(s.frame, o.inches);
    var Wm = (d.fw + 2 * MOULD_IN) * IN, Hm = (d.fh + 2 * MOULD_IN) * IN;
    var w = Wm * ROOM.fracPerMetre, h = w * (Hm / Wm) * ROOM.imgAspect;
    var maxH = ROOM.bottomY - ROOM.topMargin;
    if (h > maxH) { w *= maxH / h; h = maxH; }
    roomFrame.style.left = ((ROOM.anchorX - w / 2) * 100) + '%';
    roomFrame.style.top = ((ROOM.bottomY - h) * 100) + '%';
    roomFrame.style.width = (w * 100) + '%';
    roomFrame.style.height = (h * 100) + '%';
    layout(roomFrame, d);
  }
  function renderSizes() {
    $$('[data-frl-size]').forEach(function (btn) {
      var s = sizeObj(btn.getAttribute('data-frl-size')), o = s[state.style], d = dims(s.frame, o.inches);
      var box = $('.frl-size__frame', btn);
      box.style.width = 'calc(var(--frl-ppi) * ' + (d.fw + 2 * MOULD_IN).toFixed(2) + ')';
      box.style.height = 'calc(var(--frl-ppi) * ' + (d.fh + 2 * MOULD_IN).toFixed(2) + ')';
      layout(box, d);
      btn.setAttribute('aria-checked', String(s.key === state.size));
      var from = $('.frl-size__from', btn);
      if (from) from.textContent = 'from ' + money(fromPrice(o));
      // With a matt the A2 frame holds an A3 print; the strip says so next to its price.
      var cmEl = $('.frl-size__cm', btn);
      if (cmEl) cmEl.textContent = state.style === 'matt' && o.print === 'A3' ? 'A3 print, matted' : s.cm;
    });
  }
  function renderPanel() {
    var s = sizeObj(state.size), o = opt(), tiers = tiersOf(o);
    if (tiers.indexOf(state.tier) < 0) state.tier = tiers.indexOf('standard') >= 0 ? 'standard' : tiers[0];
    $$('[data-frl-tier]').forEach(function (b) {
      var t = b.getAttribute('data-frl-tier');
      b.hidden = tiers.indexOf(t) < 0;
      b.setAttribute('aria-checked', String(t === state.tier));
    });
    $$('[data-frl-style]').forEach(function (b) { b.setAttribute('aria-checked', String(b.getAttribute('data-frl-style') === state.style)); });
    var amount = $('[data-frl-price]'), desc = $('[data-frl-desc]'), scale = $('[data-frl-scale]');
    if (amount) amount.textContent = money(o.prices[state.tier]);
    if (desc) {
      var printLabel = o.print.replace('x', 'x') + (/^A\d$/.test(o.print) ? '' : '″');
      // A3 is printed and matted in the A2 frame, so it is priced as an A2 frame: say so (owner 2026-10-21).
      desc.textContent = (state.style === 'matt' && o.print === 'A3')
        ? 'A3 print, matted in an A2 frame (' + s.cm + '), ' + TIER_LONG[state.tier] + '. Print, frame and glass included.'
        : s.label + ' frame (' + s.cm + '), ' +
          (state.style === 'edge' ? 'your photo fills it edge to edge'
            : (/^(8|11|18|A)/.test(o.print) ? 'an ' : 'a ') + printLabel + ' print in a white matt') +
          ', ' + TIER_LONG[state.tier] + '. Print, frame and glass included.';
    }
    if (scale) scale.textContent = s.label + ' frame, drawn to scale';
  }
  function renderAll() { renderRoom(); renderSizes(); renderPanel(); renderFit(); }

  $$('[data-frl-size]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.size = b.getAttribute('data-frl-size'); state.sizeChosen = true; userTouched(); renderAll();
      track('frl_swatch', { frl_kind: 'size', frl_value: state.size, frl_sharp: state.px ? sharpAt(state.size, state.style) : null });
    });
  });
  $$('[data-frl-style]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.style = b.getAttribute('data-frl-style'); userTouched(); autoSize(); renderAll();
      track('frl_swatch', { frl_kind: 'style', frl_value: state.style });
    });
  });
  $$('[data-frl-tier]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.tier = b.getAttribute('data-frl-tier'); userTouched(); autoSize(); renderAll();
      track('frl_swatch', { frl_kind: 'tier', frl_value: state.tier });
    });
  });
  $$('[data-frl-fit-use]').forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.getAttribute('data-size');
      if (!k) return;
      state.size = k; state.sizeChosen = true; renderAll();
      track('frl_swatch', { frl_kind: 'size', frl_value: k, frl_from_warning: true });
    });
  });

  /* ---------------- try your own photo ---------------- */
  var photoImgs = $$('img[data-frl-photo]');
  // The phone hero is a <picture> with a landscape <source>; a matching source outranks
  // img.src, so the sources switch to the visitor's photo as well.
  var photoSources = $$('source[data-frl-photo]');
  photoImgs.concat(photoSources).forEach(function (el) {
    el.setAttribute('data-frl-src', el.getAttribute('src') || '');
    el.setAttribute('data-frl-srcset', el.getAttribute('srcset') || '');
  });
  function say(msg) { var n = $('[data-frl-msg]'); if (n) { n.textContent = msg; n.hidden = !msg; } }
  function usePhoto(file) {
    if (!file) return;
    if (file.type && !/^image\//.test(file.type)) { say('That file is not a photo. Try a JPEG or PNG.'); return; }
    var url = URL.createObjectURL(file), probe = new Image();
    probe.onload = function () {
      if (state.url) URL.revokeObjectURL(state.url);
      state.file = file; state.url = url;
      state.landscape = probe.naturalWidth > probe.naturalHeight * 1.03;
      state.px = [probe.naturalWidth, probe.naturalHeight];
      // The hero frame keeps a print's proportions (A-series, portrait or landscape) and the
      // photo crops to fit, so a tall phone shot or a panorama never stretches the frame.
      // Phones open on a landscape sample, but a portrait photo still gets a portrait frame
      // rather than a hard crop.
      root.style.setProperty('--frl-ar', state.landscape ? '1414 / 1000' : '1000 / 1414');
      root.classList.toggle('is-portrait-photo', !state.landscape);
      photoImgs.forEach(function (img) { img.removeAttribute('srcset'); img.src = url; });
      photoSources.forEach(function (s) { s.setAttribute('srcset', url); });
      root.classList.add('has-photo');
      userTouched();
      autoSize();
      renderAll();
      say(tooSmallForAll() ? TOO_SMALL : '');
      track('frl_try_photo', {
        frl_orientation: state.landscape ? 'landscape' : 'portrait',
        frl_px: state.px[0] + 'x' + state.px[1],
        frl_size: state.size, frl_style: state.style,
        frl_sharp: sharpAt(state.size, state.style), frl_too_small: tooSmallForAll()
      });
    };
    probe.onerror = function () {
      URL.revokeObjectURL(url);
      say('This browser cannot preview that file (HEIC and RAW files often cannot). You can still upload it on the order page.');
    };
    probe.src = url;
  }
  function useSamples() {
    if (state.url) URL.revokeObjectURL(state.url);
    state.file = null; state.url = null; state.landscape = false; state.px = null;
    say('');
    root.style.removeProperty('--frl-ar');
    root.classList.remove('is-portrait-photo');
    photoImgs.forEach(function (img) {
      img.src = img.getAttribute('data-frl-src');
      var ss = img.getAttribute('data-frl-srcset'); if (ss) img.setAttribute('srcset', ss);
    });
    photoSources.forEach(function (s) { s.setAttribute('srcset', s.getAttribute('data-frl-srcset')); });
    root.classList.remove('has-photo');
    renderAll();
  }
  var fileInput = document.getElementById('frl-file');
  if (fileInput) fileInput.addEventListener('change', function () {
    var f = fileInput.files && fileInput.files[0];
    if (f) usePhoto(f);
    fileInput.value = '';
  });
  $$('[data-frl-pick]').forEach(function (b) {
    b.addEventListener('click', function () { if (fileInput) fileInput.click(); track('frl_pick_click'); });
  });
  $$('[data-frl-samples]').forEach(function (b) { b.addEventListener('click', useSamples); });
  /* Drop a photo anywhere on the hero or the room. */
  $$('[data-frl-drop]').forEach(function (zone) {
    zone.addEventListener('dragover', function (e) { if (e.dataTransfer && Array.prototype.indexOf.call(e.dataTransfer.types || [], 'Files') >= 0) { e.preventDefault(); zone.classList.add('is-over'); } });
    zone.addEventListener('dragleave', function () { zone.classList.remove('is-over'); });
    zone.addEventListener('drop', function (e) {
      zone.classList.remove('is-over');
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) { e.preventDefault(); usePhoto(f); }
    });
  });

  /* ---------------- ordering (handoff to the order page) ---------------- */
  function putHandoff(payload) {
    return new Promise(function (resolve) {
      try {
        var req = indexedDB.open(HANDOFF_DB, 1);
        req.onupgradeneeded = function () { req.result.createObjectStore(HANDOFF_STORE); };
        req.onerror = function () { resolve(false); };
        req.onsuccess = function () {
          try {
            var tx = req.result.transaction(HANDOFF_STORE, 'readwrite');
            tx.objectStore(HANDOFF_STORE).put(payload, HANDOFF_KEY);
            tx.oncomplete = function () { resolve(true); };
            tx.onerror = function () { resolve(false); };
          } catch (err) { resolve(false); }
        };
      } catch (err) { resolve(false); }
    });
  }
  /* Safari Private Browsing cannot keep a File in IndexedDB ("Error preparing
     Blob/File data to be stored in object store", found 2026-10-30), so the photo
     never reached the order page and the visitor landed on an empty upload screen.
     Retry with the photo's bytes; the order page (framingHandoff.ts) reads either. */
  function withBytes(payload) {
    var f = payload.file;
    if (!f || typeof f.arrayBuffer !== 'function') return Promise.resolve(null);
    return f.arrayBuffer().then(function (buf) {
      var copy = {};
      for (var k in payload) if (k !== 'file') copy[k] = payload[k];
      copy.bytes = buf;
      return copy;
    }, function () { return null; });
  }
  function saveHandoff(payload) {
    return putHandoff(payload).then(function (ok) {
      if (ok) return true;
      return withBytes(payload).then(function (copy) { return copy ? putHandoff(copy) : false; })
        .then(function (ok2) { track('frl_handoff_fallback', { frl_saved: ok2 }); return ok2; });
    });
  }
  $$('[data-frl-order]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var o = opt(), s = sizeObj(state.size);
      var base = root.getAttribute('data-order-url') || '/pages/order-prints';
      var href = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'from=framing';
      var info = { frl_size: s.key, frl_style: state.style, frl_tier: state.tier, frl_colour: state.colour, frl_has_photo: !!state.file };
      if (!state.file) { track('frl_order_click', info); a.href = href; return; }
      e.preventDefault();
      if (tooSmallForAll()) {
        // Never hand off a print the order page would block: say why here instead.
        say(TOO_SMALL); renderFit();
        var near = a.closest('.frl-panel') ? $('[data-frl-fit]') : $('[data-frl-msg]');
        if (near && near.scrollIntoView) near.scrollIntoView({ block: 'center', behavior: 'smooth' });
        track('frl_too_small', { frl_px: state.px ? state.px[0] + 'x' + state.px[1] : '' });
        return;
      }
      info.frl_sharp = sharpAt(state.size, state.style);
      info.frl_print = o.print;
      a.setAttribute('aria-busy', 'true');
      saveHandoff({
        v: 1, ts: Date.now(), file: state.file, name: state.file.name || 'photo.jpg', type: state.file.type || 'image/jpeg',
        printSize: o.print, frameSize: s.key, border: o.border, tier: state.tier, colour: state.colour
      }).then(function (ok) {
        track('frl_order_click', info);
        if (ok) track('frl_handoff', info);
        location.href = href + (ok ? '&handoff=1' : '');
      });
    });
  });

  /* ---------------- live prices ---------------- */
  function applyPricing(data) {
    var pc = data && data.printCheck && data.printCheck.minDpi;
    if (pc && pc.fineArt > 0 && pc.ctype > 0) CHECK.minDpi = { ctype: Number(pc.ctype), fineArt: Number(pc.fineArt) };
    var pl = (data && data.productLines) || {}, loose = {};
    ['fine_art', 'ctype_standard', 'ctype_enlargements'].forEach(function (id) {
      ((pl[id] && pl[id].sizes) || []).forEach(function (z) { if (z && z.size) loose[z.size] = 1; });
    });
    if (Object.keys(loose).length) SIZES.forEach(function (s) { s.edge.orderable = !!loose[s.edge.print]; s.matt.orderable = !!loose[s.matt.print]; });
    var cfg = data && data.productLines && data.productLines.framing && data.productLines.framing.configs;
    if (!cfg) return;
    SIZES.forEach(function (s) {
      ['edge', 'matt'].forEach(function (style) {
        var o = s[style], next = {};
        ['ctype', 'standard', 'premium'].forEach(function (tier) {
          (cfg[tier] || []).forEach(function (row) {
            var isEdge = row.border === 'printToEdge';
            if (row.frameSize === s.key && row.printSize === o.print && isEdge === (style === 'edge')) {
              next[tier] = Number(row.price); o.border = row.border;
            }
          });
        });
        if (Object.keys(next).length) o.prices = next;
      });
    });
    autoSize();   // prices can change which tiers exist, and so the sharp size
    $$('[data-frl-p]').forEach(function (cell) {
      var p = cell.getAttribute('data-frl-p').split('|');
      (cfg[p[0]] || []).forEach(function (row) {
        if (row.printSize === p[1] && row.frameSize === p[2]) cell.textContent = money(Number(row.price));
      });
    });
    renderAll();
  }
  try {
    fetch('/apps/print/api/pricing', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j && j.data) applyPricing(j.data); })
      .catch(function () {});
  } catch (err) {}

  setColour(state.colour, false);
  renderAll();

  /* A photo tried in the home page's framed band arrives once (key framing-try, frl-home.js). */
  if (q.get('tried') === '1') {
    try {
      q.delete('tried');
      history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q.toString() : '') + location.hash);
      var hreq = indexedDB.open(HANDOFF_DB, 1);
      hreq.onupgradeneeded = function () { if (!hreq.result.objectStoreNames.contains(HANDOFF_STORE)) hreq.result.createObjectStore(HANDOFF_STORE); };
      hreq.onsuccess = function () {
        try {
          var st = hreq.result.transaction(HANDOFF_STORE, 'readwrite').objectStore(HANDOFF_STORE);
          var g = st.get('framing-try');
          g.onsuccess = function () {
            var r = g.result;
            st.delete('framing-try');
            // The photo is r.file, or r.bytes from Safari Private Browsing (see withBytes).
            var src = r && r.file && r.file.size ? r.file : (r && r.bytes && r.bytes.byteLength ? r.bytes : null);
            if (!src || typeof r.ts !== 'number' || Date.now() - r.ts > 2 * 3600 * 1000) return;
            var f = src instanceof File ? src : new File([src], r.name || 'photo.jpg', { type: r.type || src.type || 'image/jpeg' });
            if (r.colour === 'white' || r.colour === 'black') setColour(r.colour, false);
            usePhoto(f);
          };
        } catch (err) {}
      };
    } catch (err) {}
  }
})();
